import { MountedChapterIndex } from '@/utils/ordinalSync';

let activeReaderRoot: HTMLElement | null = null;
const mountedChapterIndexes = new Map<string, MountedChapterIndex>();

export const setActiveReaderRoot = (root: HTMLElement | null): void => {
  activeReaderRoot = root;
  if (!root) {
    mountedChapterIndexes.clear();
  }
};

export const getActiveReaderRoot = (): HTMLElement | null => {
  if (activeReaderRoot && !activeReaderRoot.isConnected) {
    activeReaderRoot = null;
  }
  return activeReaderRoot;
};

export const registerMountedChapterIndex = (
  chapterId: string,
  index: MountedChapterIndex,
): void => {
  mountedChapterIndexes.set(chapterId, index);
};

export const unregisterMountedChapterIndex = (chapterId: string): void => {
  mountedChapterIndexes.delete(chapterId);
};

export const getMountedChapterIndex = (chapterId: string): MountedChapterIndex | null => {
  const index = mountedChapterIndexes.get(chapterId);
  if (index && index.root.isConnected) {
    return index;
  }
  mountedChapterIndexes.delete(chapterId);
  return null;
};
